import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  scroll-behavior: unset;
  margin-top: -48px;
`;

export const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  transition: transform 0.5s ease;
  width: 100%;
`;